import { useInfiniteQuery } from '@tanstack/react-query'
import { getGetPharmacyOrdersQueryKey, getPharmacyOrders } from 'api/generated/pharmacy-order/pharmacy-order'
import type {
  GetPharmacyOrdersParams,
  PharmacyOrderCollectionItemDoctorApiOutContract,
} from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'
import { ORDERS_PAGE_SIZE } from '../constants'

// Filter/sort/search params, minus the pagination fields the hook owns.
export type PharmacyOrderQuery = Omit<GetPharmacyOrdersParams, 'Cursor' | 'Count'>

type UsePharmacyOrdersResult = {
  items: PharmacyOrderCollectionItemDoctorApiOutContract[]
  totalOrderCount: number
  totalShippingCost: number
  isLoading: boolean
  isError: boolean
  hasNextPage: boolean
  isFetchingNextPage: boolean
  fetchNextPage: () => void
}

// Cursor-paginated wrapper over GET /api/v1/pharmacy/orders. Orval's generated
// infinite hook does not thread the cursor into the request (the spec has no
// cursor-param binding), so we compose useInfiniteQuery around the generated
// request fn ourselves — the generated fetcher is still the single source of truth.
export function usePharmacyOrders(params: PharmacyOrderQuery): UsePharmacyOrdersResult {
  // Cursor is a string, absent on the first page.
  const initialPageParam: string | undefined = undefined

  const query = useInfiniteQuery({
    queryKey: getGetPharmacyOrdersQueryKey(params),
    // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
    queryFn: ({ pageParam, signal }) =>
      // @ts-expect-error TS2379 -- MIGRATION: not approved, fix when encountered
      getPharmacyOrders({ ...params, Count: ORDERS_PAGE_SIZE, Cursor: pageParam }, undefined, signal),
    initialPageParam,
    getNextPageParam: (lastPage) => lastPage.NextCursor ?? undefined,
  })

  const pages = query.data?.pages ?? []
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const items = pages.flatMap((page) => page.Items ?? [])
  // Summary stats are identical across pages; read them off the first page.
  const summary = pages[0]

  return {
    items,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    totalOrderCount: summary?.TotalOrderCount ?? 0,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    totalShippingCost: summary?.TotalShippingCost ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
    hasNextPage: query.hasNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
    fetchNextPage: query.fetchNextPage,
  }
}
